"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVaultInfoFromVault = exports.getAllVaultsWithDescription = exports.getAddressRoleOnVault = exports.getVaultDescriptionHash = exports.getAllVaultsAddressesByChain = exports.getVaultInfoWithCommittee = exports.getAllVaultsInfoWithCommittee = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = require("../config");
const gnosis_utils_1 = require("./gnosis.utils");
const ipfs_utils_1 = require("./ipfs.utils");
const vaultEditor_utils_1 = require("./vaultEditor.utils");
const getAllVaultsInfoWithCommittee = async () => {
    try {
        const GET_ALL_VAULTS = `
      query getVaults {
        vaults {
          id
          pid
          registered
          version
          committee
          master {
            id
          }
        }
      }
    `;
        const subgraphsRequests = Object.values(config_1.ChainsConfig).map((chain) => {
            return axios_1.default.post(chain.subgraph, JSON.stringify({
                query: GET_ALL_VAULTS,
            }), {
                headers: {
                    "Content-Type": "application/json",
                },
            });
        });
        const subgraphsResponses = await Promise.all(subgraphsRequests);
        const subgraphsData = subgraphsResponses.map((res) => res.data);
        const vaults = [];
        for (let i = 0; i < subgraphsData.length; i++) {
            const chainId = Object.values(config_1.ChainsConfig)[i].chain.id;
            if (!subgraphsData[i].data || !subgraphsData[i].data.vaults)
                continue;
            for (const vault of subgraphsData[i].data.vaults) {
                vaults.push({
                    chainId,
                    address: vault.id,
                    master: vault.master.id,
                    pid: vault.pid,
                    version: vault.version,
                    committee: vault.committee,
                    registered: vault.registered,
                });
            }
        }
        return vaults;
    }
    catch (error) {
        return [];
    }
};
exports.getAllVaultsInfoWithCommittee = getAllVaultsInfoWithCommittee;
const getVaultInfoWithCommittee = async (vaultId, chainId) => {
    var _a, _b;
    try {
        if (!vaultId || !chainId)
            return undefined;
        const GET_VAULT_BY_ID = `
      query getVaults($vaultId: String) {
        vaults(where: {id: $vaultId}) {
          id
          pid
          registered
          version
          committee
          master {
            id
          }
        }
      }
    `;
        const subgraphResponse = axios_1.default.post(config_1.ChainsConfig[chainId].subgraph, JSON.stringify({
            query: GET_VAULT_BY_ID,
            variables: { vaultId },
        }), {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const subgraphData = (await subgraphResponse).data;
        const vault = (_b = (_a = subgraphData === null || subgraphData === void 0 ? void 0 : subgraphData.data) === null || _a === void 0 ? void 0 : _a.vaults) === null || _b === void 0 ? void 0 : _b[0];
        if (!vault)
            return undefined;
        return {
            chainId,
            address: vault.id,
            master: vault.master.id,
            pid: vault.pid,
            version: vault.version,
            committee: vault.committee,
            registered: vault.registered,
        };
    }
    catch (error) {
        return undefined;
    }
};
exports.getVaultInfoWithCommittee = getVaultInfoWithCommittee;
const getAllVaultsAddressesByChain = async (chainId) => {
    var _a;
    if (!chainId)
        return [];
    try {
        const GET_VAULTS = `
    query getVaults {
      vaults(where: {version_not: "v1"}) {
        id
        registered
      }
    }
  `;
        const subgraphResponse = axios_1.default.post(config_1.ChainsConfig[chainId].subgraph, JSON.stringify({
            query: GET_VAULTS,
        }), {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const subgraphData = (await subgraphResponse).data;
        const vaults = (_a = subgraphData === null || subgraphData === void 0 ? void 0 : subgraphData.data) === null || _a === void 0 ? void 0 : _a.vaults;
        if (!vaults)
            return [];
        return vaults;
    }
    catch (error) {
        return [];
    }
};
exports.getAllVaultsAddressesByChain = getAllVaultsAddressesByChain;
const getVaultDescriptionHash = async (vaultId, chainId) => {
    var _a, _b;
    try {
        if (!vaultId || !chainId)
            return undefined;
        const GET_VAULT_BY_ID = `
      query getVaults($vaultId: String) {
        vaults(where: {id: $vaultId}) {
          id
          descriptionHash
        }
      }
    `;
        const subgraphResponse = axios_1.default.post(config_1.ChainsConfig[chainId].subgraph, JSON.stringify({
            query: GET_VAULT_BY_ID,
            variables: { vaultId },
        }), {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const subgraphData = (await subgraphResponse).data;
        const vault = (_b = (_a = subgraphData === null || subgraphData === void 0 ? void 0 : subgraphData.data) === null || _a === void 0 ? void 0 : _a.vaults) === null || _b === void 0 ? void 0 : _b[0];
        if (!vault)
            return undefined;
        return vault.descriptionHash;
    }
    catch (error) {
        return undefined;
    }
};
exports.getVaultDescriptionHash = getVaultDescriptionHash;
const getAddressRoleOnVault = async (address, vaultChainId, vaultCommittee) => {
    if (!address || !vaultCommittee || !vaultChainId)
        return "none";
    const govMultisig = config_1.ChainsConfig[Number(vaultChainId)].govMultisig;
    const committeeMultisig = vaultCommittee;
    const isCommitteeMultisig = committeeMultisig === address;
    const isCommitteeMultisigMember = await (0, gnosis_utils_1.isAddressAMultisigMember)(committeeMultisig, address, vaultChainId);
    const isGovMember = await (0, gnosis_utils_1.isAddressAMultisigMember)(govMultisig, address, vaultChainId);
    if (isCommitteeMultisigMember)
        return "committee";
    if (isCommitteeMultisig)
        return "committee-multisig";
    if (isGovMember)
        return "gov";
    return "none";
};
exports.getAddressRoleOnVault = getAddressRoleOnVault;
const getAllVaultsWithDescription = async (onlyMainnet = true) => {
    try {
        const GET_ALL_VAULTS = `
      query getVaults {
        vaults {
          id
          pid
          registered
          descriptionHash
        }
      }
    `;
        const subgraphsRequests = Object.values(config_1.ChainsConfig)
            .filter((chain) => (onlyMainnet ? !chain.chain.testnet : true))
            .map((chain) => {
            return fetch(chain.subgraph, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    query: GET_ALL_VAULTS,
                }),
            });
        });
        const subgraphsResponses = await Promise.all(subgraphsRequests);
        const subgraphsData = await Promise.all(subgraphsResponses.map((res) => res.json()));
        const vaults = [];
        for (let i = 0; i < subgraphsData.length; i++) {
            const chainId = Object.values(config_1.ChainsConfig)[i].chain.id;
            if (!subgraphsData[i].data || !subgraphsData[i].data.vaults)
                continue;
            for (const vault of subgraphsData[i].data.vaults) {
                vaults.push(Object.assign({ chainId }, vault));
            }
        }
        const loadVaultDescription = async (vault) => {
            if ((0, ipfs_utils_1.isValidIpfsHash)(vault.descriptionHash)) {
                try {
                    const dataResponse = await fetch(`https://ipfs2.hats.finance/ipfs/${vault.descriptionHash}`);
                    if (dataResponse.status === 200) {
                        const object = await dataResponse.json();
                        return (0, vaultEditor_utils_1.fixObject)(object);
                    }
                    return undefined;
                }
                catch (error) {
                    // console.error(error);
                    return undefined;
                }
            }
            return undefined;
        };
        // Load descriptions
        const getVaultsData = async (vaultsToFetch) => Promise.all(vaultsToFetch.map(async (vault) => {
            const description = (await loadVaultDescription(vault));
            return Object.assign(Object.assign({}, vault), { description });
        }));
        const vaultsWithDescription = await getVaultsData(vaults);
        return vaultsWithDescription;
    }
    catch (error) {
        return [];
    }
};
exports.getAllVaultsWithDescription = getAllVaultsWithDescription;
const getVaultInfoFromVault = (vault) => {
    return {
        version: vault.version,
        address: vault.id,
        chainId: vault.chainId,
        master: vault.master.address,
        pid: vault.pid,
    };
};
exports.getVaultInfoFromVault = getVaultInfoFromVault;
